import { z } from "zod";

import { AdvancedSettingsSchema, DEFAULT_ADVANCED_SETTINGS } from "../Advanced.schema";
import { DEFAULT_RATE_LIMIT_SETTINGS, RateLimitSettingsSchema } from "../RateLimit.schema";

export const OutlookAddInDeploymentSettingsSchema = z.object({
  embedSettings: z.object({
    showHeader: z.boolean().default(true)
  }),
  advancedSettings: AdvancedSettingsSchema,
  rateLimitSettings: RateLimitSettingsSchema.optional()
});

export type OutlookAddInDeploymentSettings = z.infer<typeof OutlookAddInDeploymentSettingsSchema>;

export const DEFAULT_OUTLOOK_ADDIN_SETTINGS: OutlookAddInDeploymentSettings = {
  embedSettings: { showHeader: true },
  advancedSettings: DEFAULT_ADVANCED_SETTINGS,
  rateLimitSettings: DEFAULT_RATE_LIMIT_SETTINGS
};

/** Create Outlook Add-in deployment settings with defaults. Accepts unknown (raw Prisma JsonValue). */
export function createOutlookAddInDeploymentSettings(
  overrides?: unknown
): OutlookAddInDeploymentSettings {
  if (!overrides || typeof overrides !== "object" || Array.isArray(overrides)) {
    return { ...DEFAULT_OUTLOOK_ADDIN_SETTINGS };
  }
  return { ...DEFAULT_OUTLOOK_ADDIN_SETTINGS, ...overrides } as OutlookAddInDeploymentSettings;
}
